import { render, staticRenderFns } from "./AMOS.vue?vue&type=template&id=26b8d5f3"
import script from "./AMOS.vue?vue&type=script&setup=true&lang=js"
export * from "./AMOS.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports